import createIcon from '../../createIcon';

/**
 * @component @name SignalWifiStatusbarNull
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMy41QzcuMzEgMy41IDMuMDcgNS40IDAgOC40OEwxMiAyMC41TDI0IDguNDhDMjAuOTMgNS40IDE2LjY5IDMuNSAxMiAzLjVaTTIuOTIgOC41N0M1LjUxIDYuNTggOC42NyA1LjUgMTIgNS41QzE1LjMzIDUuNSAxOC40OSA2LjU4IDIxLjA4IDguNTdMMTIgMTcuNjdMMi45MiA4LjU3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifiStatusbarNull = createIcon('SignalWifiStatusbarNull', [
  [
    'path',
    {
      d: 'M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L12 17.67L2.92 8.57Z',
      key: 'e86psn',
    },
  ],
]);

export default SignalWifiStatusbarNull;
